// Generated by CoffeeScript 2.7.0
import Admin__MembersController from './members.js';

Skylark.App.Controllers.register({Admin__MembersController});
